const formatText = (input) => {
  if (!input || typeof input !== "string") return "";

  return (
    input
      // Split by space but keep spaces in result
      .split(/(\s+)/)
      .map((word) => {
        // Find first alphabetic character
        const match = word.match(/[a-zA-Z]/);
        if (match) {
          const index = match.index;
          return (
            word.slice(0, index) +
            word.charAt(index).toUpperCase() +
            word.slice(index + 1).toLowerCase()
          );
        }
        return word; // if no alphabetic character, keep as-is
      })
      .join("")
  );
};

export default formatText;
